import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import axios from 'axios';
import { jsonpPost } from '../../../utils/jsonp';
import $ from 'jquery';
import emailjs from '@emailjs/browser';


class Iscrizioni_workshop extends Component {
    
    constructor(props) {
        super(props);
        this.fineDef = React.createRef();
        this.state = ({
            "nome": '',
            "cognome": '',
            "data_nascita": null,
            "email": '',
            "cellulare": '',
            "fields": {},
            "errors": {}
        });
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["nome"]) {
            formIsValid = false;
            errors["nome"] = "Inserire il nome";
        }
        //Cognome
        if (!fields["cognome"]) {
            formIsValid = false;
            errors["cognome"] = "Inserire il cognome";
        }
        //data di nascita
        if (!fields["dataNascita"]) {
            formIsValid = false;
            errors["dataNascita"] = "Inserire la data di nascita";
        }
        if (fields["dataNascita"] < '1900-01-01') {
            formIsValid = false;
            errors["dataNascita"] = "Data di nascita non valida";
        }

        if (fields["dataNascita"] >= '2017-01-01') {
            formIsValid = false;
            errors["dataNascita"] = "Data di nascita non valida";
        }
       
        //email
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "Inserire indirizzo email";
        } else if (typeof fields["email"] != '' && !(regex.test(fields["email"]))) {
            formIsValid = false;
            errors["email"] = "Indirizzo email non valido";
            console.log('email non valida');
        }

        //cellulare
        var regex2 = /^(\+|)*[0-9\s\/\-]*$/;
        if (fields["cellulare"] && (!(regex2.test(fields["cellulare"])) || (fields["cellulare"].length) < 10)) {
            formIsValid = false;
            errors["cellulare"] = "Numero di cellulare non valido";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = (e.target.value).trim();
        this.setState({ fields });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        $('#submit').prop('disabled', true);;
        if (!this.handleValidation()) {
            console.log('Show Errori');
            $('#submit').prop('disabled', false);
        } else {
            e.preventDefault();

            $('#image-loader').fadeIn();
            jsonpPost('https://script.google.com/macros/s/AKfycbzSWBGYVjFKLDt9SLNvPcyn6VpECdgv4Iazw55CQygD08q9ZeerREFV1m4Ee30fFiv73g/exec?tabId=Cypher', [{
                    "Nome": this.state.fields.nome,
                    "Cognome": this.state.fields.cognome,
                    "Data Nascita": this.state.fields.dataNascita,
                    "Email": this.state.fields.email,
                    "Cellulare": this.state.fields.cellulare,
                    "Data Iscrizione": new Date().toLocaleString()
                }])
                .then((response) => {
                    if (response && response.message === "Successfully Inserted") {
                         
                        var templateParams = {
                            nome: this.state.fields.nome,
                            destinatario: this.state.fields.email
                        };
                         
                       emailjs.send('service_p7osjee', 'template_j0hg4qa', templateParams, 'r0Wf09cOIWs_LW8Qt')
                            .then(function(response) {
                               console.log('SUCCESS!', response.status, response.text);
                            }, function(error) {
                               console.log('FAILED...', error);
                            });
                        $("#image-loader").fadeOut();
                        $("#message-warning").hide();
                        $("#form_iscrizione").css("display", "none");
                        $("#message-success").fadeIn();
                        $('#form_iscrizione')[0].reset();
                    } else {
                        $("#image-loader").fadeOut();
                        $("#message-warning").fadeIn();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    $("#image-loader").fadeOut();
                    $("#message-warning").fadeIn();
                });
        }
    }

    render() {
        if (!this.props.data) return null;

        const img_header = "/images//" + this.props.data.cypher_workshop.img_header_iscrizioni_cypher;
        const img_header_mobile = "/images/" + this.props.data.cypher_workshop.img_header_iscrizioni_cypher_mobile;
        
        const name_nome = this.props.data.stage.name_form.nome;
        const name_cognome = this.props.data.stage.name_form.cognome;
        const name_data_nascita = this.props.data.stage.name_form.dataNascita;
        const name_email = this.props.data.stage.name_form.email;
        const name_cellulare = this.props.data.stage.name_form.cellulare;


        return (
            <section id="contact">
                <Fade bottom duration={1000}>
                    <div className="row">
                        <img id="img_header_lg" src={img_header} />
                        <img id="img_header_xs" src={img_header_mobile} />
                        <img scr={img_header}/>
                    </div>
                </Fade>
                <div alt="footer" id="message-warning" className="text-center"> Attenzione! Si è verificato un errore imprevisto, riprovare!</div>
                <div alt="footer" id="message-success" className="text-center">
                    <i className="fa fa-check"></i><h3>La tua iscrizione è stata inserita correttamente! </h3>
                    <br/> A breve riceverai una mail di conferma contenente le indicazioni per il pagamento tramite PayPal. <br/>
                    Se non dovessi ricevere la mail di conferma entro 24 ore ti preghiamo di contattarci. Grazie! 
                    <br/>
                    <a style={{ paddingLeft: "00%" }} href="/cypherworkshop"><button style={{ backgroundColor: "#38aae1", marginTop:"50px", marginRight:"10px" }}>Home</button></a>
                    <a style={{ paddingLeft: "00%" }} href="/cypherworkshop/iscrizioni"><button style={{ backgroundColor: "#38aae1", marginTop:"50px" }}>Nuova iscrizione</button></a>
                    <br />
                </div>
                <div className="row" id="div_main">
                    <Slide left duration={1000}>
                        <form id="form_iscrizione">
                            <fieldset>
                                <div >
                                    <hr style={{ border: "solid 1px #38aae1" }} />
                                    <div className="six columns divColumn">
                                        <label htmlFor="nome">
                                            Nome <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="35"
                                            id="nome"
                                            name={name_nome}
                                            required
                                            onChange={this.handleChange.bind(this, "nome")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["nome"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="cognome">
                                            Cognome <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="35"
                                            id="cognome"
                                            name={name_cognome}
                                            required
                                            onChange={this.handleChange.bind(this, "cognome")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["cognome"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="dataNascita">
                                            Data nascita <span className="required">*</span>
                                        </label>
                                        <input
                                            style={{ display: "block" }}
                                            type="date"
                                            min="1918-01-01" max="2022-01-31"
                                            id="dataNascita"
                                            name={name_data_nascita}
                                            required
                                            onChange={this.handleChange.bind(this, "dataNascita")}
                                            requiredpattern="\d{4}-\d{2}-\d{2}"
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["dataNascita"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="email">
                                            Email <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue=""
                                            size="150"
                                            id="email"
                                            name={name_email}
                                            required
                                            onChange={this.handleChange.bind(this, "email")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["email"]}</span>
                                    </div>

                                    <div className="six columns divColumn">
                                        <label htmlFor="cellulare">
                                            Cellulare
                                        </label>
                                        <input
                                            type="tel"
                                            defaultValue=""
                                            size="35"
                                            id="cellulare"
                                            name={name_cellulare}
                                            onChange={this.handleChange.bind(this, "cellulare")}
                                        />
                                        <span style={{ color: "red", "fontSize": "12px" }}>{this.state.errors["cellulare"]}</span>
                                    </div>

                                    <hr style={{ border: "solid 1px #38aae1", "marginTop": "43px" }} />
                                    <div className="twelve columns align-center">
                                    <button type="submit" className="submit" style={{backgroundColor:"#38aae1"}} id="submit" onClick={this.handleSubmit}>Invia </button>
                                        <span id="image-loader">
                                            <img alt="" src="/images/loader.gif" />
                                        </span>
                                    </div>


                                </div>


                            </fieldset>
                        </form>
                    </Slide>
                </div>

            </section>
        );
    }
}

export default Iscrizioni_workshop;
